import React from 'react';
import styled from '@emotion/styled';
import { RTCTask } from '../../../../core/models/rtc';
import { RTCTaskCard } from '../RTCTaskCard';

const Frame = styled.div({
    width: '357px',
    height: '799px',
    background: 'rgba(69, 76, 100, 0.7)',
    boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(25px)',
    borderRadius: '0px 0px 30px 30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
});

function indexToAlpha(order: number) {
    switch (order) {
        case 0: return 0.9;
        case 1: return 0.6;
        default: return 0.3;
    }
}

function indexToScale(order: number) {
    return Math.pow((1.0 - 0.0436), order);
}

const WrappedCard = styled(RTCTaskCard)((props: { scale: number, translateY: number }) => ({
    transform: `scale(${props.scale})`,
    marginTop: `${props.translateY * 100}%`,
}));

export type RTCTaskQueueProps = {
    className?: string;
    tasks: RTCTask[];
    maxElements?: number;
}

export function RTCTaskQueue(props: RTCTaskQueueProps) {
    const { className, tasks, maxElements } = props;

    const length = maxElements ? Math.min(tasks.length, maxElements) : tasks.length;

    return (
        <Frame className={className}>
            {
                tasks.slice(0, maxElements).reverse().map((task, index) =>
                    <WrappedCard
                        key={task.id}
                        task={task}
                        scale={indexToScale(length - index - 1)}
                        translateY={-0.10}
                        alpha={indexToAlpha(length - index - 1)}
                    />
                )
            }
        </Frame>
    );
}
